module.exports = __webpack_public_path__ + "static/media/Inclined-Kids2.32ced56f.jpg";